import { z } from 'zod'
import { Model } from '../../_kernel/architecture'

export const FacilityCodeGroupValidation = z.object({
  value: z.string({ required_error: '[FacilityCodeGroup] value is required' }),
})

export class FacilityCodeGroup extends Model {
  static create({ value }: z.infer<typeof FacilityCodeGroupValidation>) {
    FacilityCodeGroupValidation.parse({ value })
    return new FacilityCodeGroup(value)
  }

  static fromNumber(num: number) {
    return FacilityCodeGroup.create({ value: num.toString() })
  }

  static empty() {
    return new FacilityCodeGroup('')
  }

  constructor(private readonly _value: string) {
    super()
  }

  get value() { return this._value } // prettier-ignore

  toJSON() {
    return { value: this.value }
  }
}
